import Alpine from 'alpinejs';

export function guests(config = {}) {
    return {
        maxGuests: null,
        isAdjustingGuests: false,

        init() {
            const parsedMaxGuests = Number(config?.maxGuests);
            this.maxGuests = Number.isFinite(parsedMaxGuests) && parsedMaxGuests > 0
                ? Math.floor(parsedMaxGuests)
                : null;

            this.$store.search.updateGuests();

            this.$watch('$store.search.adults', () => this.enforceMaxGuests('adults'));
            this.$watch('$store.search.children', () => this.enforceMaxGuests('children'));
        },

        enforceMaxGuests(changedField) {
            if (this.isAdjustingGuests) {
                return;
            }

            const searchStore = this.$store.search;
            searchStore.updateGuests();

            if (!this.maxGuests || searchStore.guests <= this.maxGuests) {
                return;
            }

            const adults = Math.max(0, Number(searchStore.adults) || 0);
            const children = Math.max(0, Number(searchStore.children) || 0);
            const overflow = adults + children - this.maxGuests;

            let nextAdults = adults;
            let nextChildren = children;

            if (changedField === 'children') {
                nextChildren = Math.max(0, children - overflow);
            } else {
                nextAdults = Math.max(0, adults - overflow);
            }

            this.isAdjustingGuests = true;
            searchStore.adults = nextAdults;
            searchStore.children = nextChildren;
            searchStore.updateGuests();
            window.dispatchEvent(new CustomEvent('listing:guest-limit', {
                detail: { maxGuests: this.maxGuests },
            }));

            queueMicrotask(() => {
                this.isAdjustingGuests = false;
            });
        },
    };
}

document.addEventListener('alpine:init', () => {
    Alpine.data('guests', guests);
});
